module.exports = __webpack_public_path__ + "img/icon_calendar_dark.58512621.svg";